<template>
  <div id="app" v-cloak>
    <transition>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      routerFlag: true
    }
  },
  created() {
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.search("zhqd") != -1 || ua.search("zhihuiqingdaoapp") != -1) {
      this.routerFlag = true
    } else if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.routerFlag = true
    } else {
      this.routerFlag = true
      // this.$toast.fail('请在微信客户端或智慧青岛客户端打开链接');
    }

  },
  mounted() {
    // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
  },
  methods: {

  },
}
</script>
<style>
.page {
  max-width: 750px;
  margin: 0 auto;
}
</style>
